// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sana {
  text-align: center;
  min-height: 100vh;
  min-width: 100vw;
  background-color: #FFE3CC !important;
  color-scheme: light !important; 
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;AAChC","sourcesContent":[".Sana {\r\n  text-align: center;\r\n  min-height: 100vh;\r\n  min-width: 100vw;\r\n  background-color: #FFE3CC !important;\r\n  color-scheme: light !important; \r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
